import React, { useContext, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { Icon } from '@iconify/react';
import Logo from './../../assets/logo-blanco.png';
import { useDispatch, useSelector } from 'react-redux';
import { handleLogOut } from './../../redux/slices/authSlice';
import { ColorModeContext } from '../common/ThemeContext';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'drawerOpen',
})(({ theme, drawerOpen, drawerWidth }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(drawerOpen && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const NavBar = ({
  drawerOpen,
  drawerWidth,
  handleOpenDrawer,
  handleBloqueoDrawer,
}) => {
  const [sum, setSum] = useState(1);
  const { mode, toggleColorMode } = useContext(ColorModeContext);

  const t = useTheme();

  const dispatch = useDispatch();
  const { userData, keycloakData } = useSelector((state) => state.authReducer);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const toggleBloqueoDrawer = () => {
    if (!drawerOpen) {
      handleOpenDrawer(true);
    } else {
      handleOpenDrawer(false);
    }
    handleBloqueoDrawer();
  };

  /*  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  }; */

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleCierraSesion = () => {
    keycloakData.logout();
    dispatch(handleLogOut());
  };

  const settings = [
    {
      label: 'Cerrar Sesión',
      action: handleCierraSesion,
    },
  ];

  const pages = [
    {
      label: 'Menu',
      icon: (
        <Icon
          icon="solar:hamburger-menu-linear"
          className="text-white hover:text-white"
        />
      ),
      action: () => toggleBloqueoDrawer(),
    },
  ];

  return (
    <AppBar position="fixed">
      <Container maxWidth="false">
        <Toolbar disableGutters variant="dense">
          {/* vista pantallas chicas */}
          <Box
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
            onClick={() => {
              setSum(sum + 1);
              console.log(sum);
              if (sum % 100 == 0) {
                toggleColorMode();
              }
            }}
          >
            <img src={Logo} style={{ height: 24 }} alt="Logotipo Level" />
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={() => handleOpenDrawer(!drawerOpen)}
              color="inherit"
              sx={{ color: '#ffffff' }}
            >
              <Icon icon="solar:hamburger-menu-linear" />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page, index) => (
                <IconButton key={index} onClick={() => page.action()}>
                  {page.icon}
                </IconButton>
              ))}
            </Menu>
          </Box>
          {/* vista pantallas grandes */}
          <Box
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              color: 'inherit',
              textDecoration: 'none',
            }}
            onClick={() => {
              setSum(sum + 1);
              console.log(sum);
              if (sum % 100 == 0) {
                toggleColorMode();
              }
            }}
          >
            <img src={Logo} style={{ height: 24 }} alt="Logotipo Level" />
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {/*  {pages.map((page) => (
              <Button
                key={page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                {page}
              </Button>
            ))} */}
            {pages.map((page, index) => (
              <IconButton key={index} onClick={page.action}>
                {page.icon}
              </IconButton>
            ))}
          </Box>
          {/* Opciones lado derecho */}
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Opciones">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  alt={userData?.name}
                  src="/static/images/avatar/2.jpg"
                  sx={{
                    height: 30,
                    width: 30,
                    fontSize: 20,
                    color: 'primary.main',
                    bgcolor: 'white',
                  }}
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((item, key) => (
                <MenuItem
                  key={key}
                  onClick={item.action}
                  sx={{
                    '&:hover': {
                      bgcolor: 'primary.main',
                      color: '#ffffff',
                      '.MuiListItemIcon-root': { color: '#ffffff' },
                    },
                  }}
                >
                  <Typography textAlign="center" sx={{ fontSize: 12 }}>
                    {item.label}
                  </Typography>
                </MenuItem>
              ))}
              {/*
              <MenuItem
                sx={{
                  '&:hover': {
                    bgcolor: 'primary.main',
                    color: '#ffffff',
                    '.MuiListItemIcon-root': { color: '#ffffff' },
                  },
                }}
                onClick={toggleColorMode}
              >
                <Typography textAlign="center" sx={{ fontSize: 12 }}>
                  {mode === 'dark'
                    ? 'Cambiar a modo claro'
                    : 'Cambiar a modo oscuro'}
                </Typography>
              </MenuItem>
              */}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NavBar;
